import React from 'react';

import { ButtonBase } from '@material-ui/core';

import CallCenterIcon from './assets/CallCenterIcon';

import * as S from './styles';

export function Intercom() {
  return (
    <S.Container id="intercom_custom_selector">
      <ButtonBase>
        <CallCenterIcon />
      </ButtonBase>
    </S.Container>
  );
}
